import { useSWRConfig } from 'swr';

export default function useFetchConfig() {
  const { cache, mutate: globalMutate, ...rest } = useSWRConfig();

  const clearCache = () => {
    globalMutate(() => true, undefined, { revalidate: true });
  };

  const mutate = (key, value, options) => {
    if (!cache.has(key)) return;
    globalMutate(key, value, options);
  };

  const mutateAll = (baseKey, value, options) => {
    for (const key of cache.keys()) {
      if (key.startsWith(`$inf$${baseKey}`) || key.startsWith(baseKey)) {
        globalMutate(key, value, options);
      }
    }
  };

  const mutateInfinite = async (key, updateFn, options) => {
    if (cache.has(`$inf$${key}`)) {
      await globalMutate(
        `$inf$${key}`,
        (data) => {
          if (!data) return;
          return Promise.all(data.map(updateFn));
        },
        options
      );
    }
  };

  return { cache, clearCache, mutate, mutateAll, mutateInfinite, ...rest };
}
